import themeYl from './themes/theme-yl';

export default {
    'theme-yl': themeYl
}